import { render, staticRenderFns } from "./SelectedPackage.vue?vue&type=template&id=38a7323c&"
import script from "./SelectedPackage.vue?vue&type=script&lang=js&"
export * from "./SelectedPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports